var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "打印",
        visible: _vm.dialogVisible,
        width: "1200px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { attrs: { id: "print" } }, [
        _c("table", { staticClass: "gh-table" }, [
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                { staticStyle: { padding: "0" }, attrs: { colspan: "24" } },
                [
                  _c("span", { staticStyle: { "font-size": "18px" } }, [
                    _vm._v(_vm._s(_vm.storeName)),
                  ]),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "margin-left": "20px",
                      },
                    },
                    [_vm._v("门诊处方笺")]
                  ),
                ]
              ),
            ]),
            _c(
              "tr",
              {
                staticClass: "fixed-header",
                staticStyle: { "border-bottom": "1px solid #000" },
              },
              [
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("科别")]),
                _c(
                  "th",
                  { attrs: { colspan: "3" } },
                  [
                    _c("el-input", {
                      staticClass: "screen-only",
                      model: {
                        value: _vm.data.kebie,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "kebie", $$v)
                        },
                        expression: "data.kebie",
                      },
                    }),
                    _c("span", { staticClass: "print-only" }, [
                      _vm._v(_vm._s(_vm.data.kebie)),
                    ]),
                  ],
                  1
                ),
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("费别")]),
                _c(
                  "th",
                  { attrs: { colspan: "3" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "screen-only",
                        staticStyle: { width: "100px" },
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.data.feibie,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "feibie", $$v)
                          },
                          expression: "data.feibie",
                        },
                      },
                      _vm._l(_vm.feibieOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.value, value: item.value },
                        })
                      }),
                      1
                    ),
                    _c("span", { staticClass: "print-only" }, [
                      _vm._v(_vm._s(_vm.data.feibie)),
                    ]),
                  ],
                  1
                ),
                _c("th", { attrs: { colspan: "2" } }),
                _c("th", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.year)),
                ]),
                _c("th", { attrs: { colspan: "1" } }, [_vm._v("年")]),
                _c("th", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.month)),
                ]),
                _c("th", { attrs: { colspan: "1" } }, [_vm._v("月")]),
                _c("th", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.day)),
                ]),
                _c("th", { attrs: { colspan: "1" } }, [_vm._v("日")]),
                _c("th", { attrs: { colspan: "3" } }),
              ]
            ),
            _c(
              "tr",
              {
                staticClass: "fixed-header",
                staticStyle: { "border-bottom": "1px solid #000" },
              },
              [
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("门诊号")]),
                _c(
                  "th",
                  { attrs: { colspan: "12" } },
                  [
                    _c("el-input", {
                      staticClass: "screen-only",
                      model: {
                        value: _vm.data.menzhenhao,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "menzhenhao", $$v)
                        },
                        expression: "data.menzhenhao",
                      },
                    }),
                    _c("span", { staticClass: "print-only" }, [
                      _vm._v(_vm._s(_vm.data.menzhenhao)),
                    ]),
                  ],
                  1
                ),
                _c("th", { attrs: { colspan: "9" } }),
              ]
            ),
            _c(
              "tr",
              {
                staticClass: "fixed-header",
                staticStyle: { "border-bottom": "1px solid #000" },
              },
              [
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("姓名")]),
                _c("th", { attrs: { colspan: "5" } }, [
                  _vm._v(_vm._s(_vm.data.name)),
                ]),
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("年龄")]),
                _c("th", { attrs: { colspan: "3" } }, [
                  _vm._v(_vm._s(_vm.data.age)),
                ]),
                _c("th", { attrs: { colspan: "1" } }),
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("性别")]),
                _c("th", { attrs: { colspan: "1" } }, [
                  _vm._v(_vm._s(_vm.data.sexSign === "1" ? "√" : "")),
                ]),
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("男")]),
                _c("th", { attrs: { colspan: "1" } }, [
                  _vm._v(_vm._s(_vm.data.sexSign === "1" ? "" : "√")),
                ]),
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("女")]),
                _c("th", { attrs: { colspan: "3" } }),
              ]
            ),
            _c(
              "tr",
              {
                staticClass: "fixed-header",
                staticStyle: { "border-bottom": "1px solid #000" },
              },
              [
                _c("th", { attrs: { colspan: "4" } }, [_vm._v("临床诊断")]),
                _c("th", { attrs: { colspan: "20" } }),
              ]
            ),
          ]),
          _c(
            "tbody",
            { staticClass: "prescription-body" },
            [
              _vm._l(_vm.groupedMedicines, function (row, rowIndex) {
                return [
                  _c(
                    "tr",
                    { key: "row-" + rowIndex },
                    [
                      _vm._l(row, function (item, itemIndex) {
                        return [
                          _c(
                            "td",
                            {
                              key: "item-" + itemIndex,
                              staticClass: "medicine-name",
                              attrs: { colspan: "4" },
                            },
                            [_vm._v(_vm._s(item.materielName))]
                          ),
                          _c(
                            "td",
                            {
                              key: "item-" + itemIndex,
                              attrs: { colspan: "2" },
                            },
                            [_vm._v(_vm._s(item.singleNum))]
                          ),
                          _c(
                            "td",
                            {
                              key: "item-" + itemIndex,
                              attrs: { colspan: "2" },
                            },
                            [_vm._v("g")]
                          ),
                        ]
                      }),
                      row.length < 3
                        ? _vm._l((3 - row.length) * 8, function (n) {
                            return _c("td", {
                              key: "empty-" + n,
                              attrs: { colspan: "1" },
                            })
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              }),
              _vm.groupedMedicines.length < 4
                ? _vm._l(4 - _vm.groupedMedicines.length, function (n) {
                    return _c("tr", { key: "empty-row-" + n }, [
                      _c("td", { attrs: { colspan: "24" } }, [_vm._v(" ")]),
                    ])
                  })
                : _vm._e(),
            ],
            2
          ),
          _c("tr", { staticStyle: { "border-bottom": "1px solid #000" } }, [
            _c("td", { attrs: { colspan: "6" } }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.toJson(_vm.jsonStr.serveFeeSign, _vm.num.serveFeeSign)
                  ) +
                  " "
              ),
            ]),
            _c("td", { attrs: { colspan: "6" } }, [
              _vm._v(" " + _vm._s(_vm.num.doseNum) + "付 "),
            ]),
            _c("td", { attrs: { colspan: "6" } }, [
              _vm._v(" 1日" + _vm._s(_vm.num.dayFreq) + "剂 "),
            ]),
            _c("td", { attrs: { colspan: "6" } }, [
              _vm._v(" 1日" + _vm._s(_vm.num.dayDoseNum) + "次 "),
            ]),
          ]),
          _c("tfoot", [
            _c("tr", [
              _c("td", { attrs: { colspan: "2" } }, [_vm._v("医师")]),
              _c("td", {
                staticStyle: { "border-bottom": "1px solid #000" },
                attrs: { colspan: "6" },
              }),
              _c("td", { attrs: { colspan: "2" } }, [_vm._v("审核")]),
              _c("td", {
                staticStyle: { "border-bottom": "1px solid #000" },
                attrs: { colspan: "6" },
              }),
              _c("td", { attrs: { colspan: "2" } }, [_vm._v("金额")]),
              _c(
                "td",
                {
                  staticStyle: { "border-bottom": "1px solid #000" },
                  attrs: { colspan: "6" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.diagRecord.paymentAmount.toFixed(2)) +
                      "元 "
                  ),
                ]
              ),
            ]),
            _c("tr", [
              _c("td", { attrs: { colspan: "2" } }, [_vm._v("调配")]),
              _c("td", {
                staticStyle: { "border-bottom": "1px solid #000" },
                attrs: { colspan: "6" },
              }),
              _c("td", { attrs: { colspan: "2" } }, [_vm._v("核对")]),
              _c("td", {
                staticStyle: { "border-bottom": "1px solid #000" },
                attrs: { colspan: "6" },
              }),
              _c("td", { attrs: { colspan: "2" } }, [_vm._v("发药")]),
              _c("td", {
                staticStyle: { "border-bottom": "1px solid #000" },
                attrs: { colspan: "6" },
              }),
            ]),
          ]),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handlePrint } },
            [_vm._v("打 印")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }